import useIsCurrentRouteSingle from "@Route/hooks/useIsCurrentRouteSingle";
import {useTranslation} from "./useTranslation";

export default function useDirectionAwareTicketTypeTranslation() {
    const isCurrentRouteSingle = useIsCurrentRouteSingle()
    const typeLabel = useTranslation(isCurrentRouteSingle ? 'sys.outbound' : 'sys.return')
    const ticketInfoLabel = useTranslation('sys.ticket_info')

    return `${typeLabel} ${ticketInfoLabel.toLowerCase()}`
}